import React from 'react';
import { observer } from 'mobx-react';
import styled from 'styled-components';
import { Icon } from 'components';
// FIXME: To remove ThemeColors import
import ThemeColors from 'styles/themes/wikifactory/styles/colors';

export const Invitation = observer(({ invitation }) => {
  let status = '';
  let color = '';
  if (invitation.status === 'PENDING') {
    status = 'sent';
    color = '#27ae60';
  } else if (invitation.status === 'APPROVED') {
    status = 'accepted';
    color = ThemeColors.primary;
  } else {
    status = 'rejected';
    color = ThemeColors.destructiveDark;
  }
  return (
    <Wrapper>
      <WrapperIcon>
        <Icon name='email' />
      </WrapperIcon>
      <Name>{invitation.email}</Name>
      <Status color={color}>{status}</Status>
    </Wrapper>
  );
});

const Wrapper = styled.div`
  position: relative;
  width: 600px;
  margin: 0 auto;
  padding: 20px 0;
  border-bottom: 1px solid ${props => props.theme.color.wfGrey200};
`;

export const WrapperIcon = styled.div`
  width: 42px;
  height: 42px;
  background-color: ${props => props.theme.color.primary};
  color: ${props => props.theme.color.wfWhite};
  border-radius: 50%;
  line-height: 38px;
  text-align: center;
  margin-right: 15px;
`;

const Name = styled.h4`
  position: absolute;
  top: 22px;
  left: 52px;
  font-weight: 600;
`;

const Status = styled(Name)`
  bottom: 22px;
  top: unset;
  font-weight: 400;
  font-size: 0.8em;
  color: ${props => props.color};
`;
